import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryPreview() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            久久久久解决方案
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            久久久久围绕持久稳定体验构建了四大核心板块，为您提供全方位的品质选择
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="p-6 md:p-8">
                <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-lg mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                  <i className={`${category.icon} text-2xl text-accent-600`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {category.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {category.articleCount} 篇文章
                  </span>
                  <span className="text-sm text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all duration-200 whitespace-nowrap">
                    了解更多
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}